import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { GET, POST, PUT } from "../../API";
import { BASE_API_ENDPOINT, commonDealerEndPoint, glocalLogoutUrl, FETCH_DURATION } from "../../config/constant";
import { API_END_POINT } from "../../config/apiEndPoint";
import img1 from "../../assets/images/harley.jpg";

let idToken = sessionStorage.getItem("token");

export const saveCampaignData = createAsyncThunk(
  "saveCampaignData",
  async (payload) => {
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.saveCampaignData}`,
      body: payload,
    });
    return response.data;
  }
);
export const saveAdsetData = createAsyncThunk(
  "saveAdsetData",
  async (payload) => {
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.saveAdsetData}`,
      body: payload,
    });
    return response.data;
  }
);
export const saveAdsData = createAsyncThunk("saveAdsData", async (payload) => {
  const response = await POST({
    url: `${BASE_API_ENDPOINT}${API_END_POINT.saveAdsData}`,
    body: payload,
    headers: {
      "Content-Type": "multipart/form-data",
      authorization: `Bearer ${idToken}`,
    },
  });
  return response.data;
});

export const getRecentPosts = createAsyncThunk(
  "getRecentPosts",
  async (payload) => {
    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getRecentPosts}`,
      body: payload,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const postActivity = createAsyncThunk(
  "postActivity",
  async (payload, { rejectWithValue }) => {
    try {
      const idToken = sessionStorage.getItem("token");
      if (!idToken) {
        throw new Error("No token found in sessionStorage");
      }

      const response = await POST({
        url: `${BASE_API_ENDPOINT}${API_END_POINT.postActivity}`,
        body: payload,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${idToken}`,
        },
      });

      if (!response.data) {
        throw new Error("No data received from server");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to post activity");
    }
  }
);

export const deletePost = createAsyncThunk("deletePost", async (payload) => {
  const response = await axios.delete(
    `${BASE_API_ENDPOINT}${API_END_POINT.deletePost}/${payload}`,
    {
      headers: {
        authorization: `Bearer ${idToken}`,
      },
    }
  );
  return response.data;
});

export const getActivityLog = createAsyncThunk(
  "getActivityLog",
  async (payload) => {
    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getActivityLog}`,
      body: payload,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const savePostMedia = createAsyncThunk(
  "savePostMedia",
  async (payload) => {
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.savePostMedia}`,
      body: payload,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);
export const getPlatformList = createAsyncThunk(
  "getPlatformList",
  async (payload) => {
    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getPlatformList}`,
      body: payload,
    });
    return response.data;
  }
);
export const findPostById = createAsyncThunk(
  "findPostById",
  async (payload) => {
    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.findPostById}/${payload.postId}`,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);
export const createRepository = createAsyncThunk(
  "createRepository",
  async (payload) => {
    const idToken = sessionStorage.getItem("token");
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.createRepository}`,
      body: payload.payload,
      // headers: payload.headers,
      headers: {
        accessToken: sessionStorage.getItem("accessToken"),
        "Content-Type": "multipart/form-data",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);


export const getRepository = createAsyncThunk(
  "getRepository",
  async (payload) => {
    const idToken = sessionStorage.getItem("token");
    const queryString = new URLSearchParams({...payload.payload, daysCount: FETCH_DURATION}).toString();
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getRepository}?${queryString}`,
      body: payload,
      headers: {
        accessToken: sessionStorage.getItem("accessToken"),
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const getRecentRepositoryFiles = createAsyncThunk(
  "getRecentRepositoryFiles",
  async (payload) => {
    const idToken = sessionStorage.getItem("token");
    const queryString = payload?.payload ? new URLSearchParams({...payload.payload, daysCount: FETCH_DURATION}).toString() : "";
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getRepository}?${queryString}`,
      body: payload,
      headers: {
        accessToken: sessionStorage.getItem("accessToken"),
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);


export const getFolders = createAsyncThunk("getFolders", async (payload) => {
  const queryString = new URLSearchParams(payload.payload).toString();
  const response = await GET({
    url: `${BASE_API_ENDPOINT}${API_END_POINT.getRepository}?${queryString}`,
    headers: payload.headers,
  });
  return response.data;
});

export const searchRepository = createAsyncThunk(
  "searchRepository",
  async (payload) => {
    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.searchRepository}?search=${payload.payload}`,
      headers: payload.headers,
    });
    return response.data;
  }
);

export const uploadMultipleFiles = createAsyncThunk(
  "uploadMultipleFiles",
  async (payload) => {
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.uploadMultipleFiles}`,
      body: payload.payload,
      headers: payload.headers,
    });
    return response.data;
  }
);

export const downloadS3Folders = createAsyncThunk(
  "downloadS3Folders",
  async (payload) => {
    const idToken = sessionStorage.getItem("token");
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.downloadS3Folders}`,
      body: payload,
      responseType: "blob",
      headers: {
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const downloadFolder = createAsyncThunk(
  "downloadFolder",
  async (payload) => {
    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.downloadFolder}?folderId=${payload.folderId}`,
      body: payload,
      responseType: "blob",
    });
    return response.data;
  }
);

export const editRepository = createAsyncThunk(
  "editRepository",
  async ({ id, payload, headers }) => {
    const response = await PUT({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.editRepository}/${id}`,
      body: payload,
      headers,
    });
    return response.data;
  }
);

export const copyRepository = createAsyncThunk(
  "copyRepository",
  async (payload) => {
    const response = await PUT({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.copyRepository}`,
      body: payload.payload,
      headers: payload.headers,
    });
    return response.data;
  }
);

export const uploadCreative = createAsyncThunk(
  "api/uploadCreative",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const idToken = sessionStorage.getItem("token");

      if (!idToken) {
        throw new Error("No token found in sessionStorage");
      }

      const response = await POST({
        url: `${BASE_API_ENDPOINT}${API_END_POINT.uploadCreative}`,
        body: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${idToken}`,
          accessToken: sessionStorage.getItem("accessToken"),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to upload file");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getPendingCreatives = createAsyncThunk(
  "getPendingCreatives",
  async ({ payload }) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getPendingCreatives}`,
      body: payload,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);
export const getApprovedCreatives = createAsyncThunk(
  "getApprovedCreatives",
  async ({ payload }) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getApprovedCreatives}`,
      body: payload,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);
export const getRejectedCreatives = createAsyncThunk(
  "getRejectedCreatives",
  async ({ payload }) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getRejectedCreatives}`,
      body: payload,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);
export const getCreatives = createAsyncThunk(
  "getCreatives",
  async ({ payload }) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getCreatives}`,
      body: payload,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response?.data?.data;
  }
);

export const moveRepository = createAsyncThunk(
  "moveRepository",
  async (payload) => {
    const response = await PUT({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.moveRepository}`,
      body: payload.payload,
      headers: payload.headers,
    });
    return response.data;
  }
);

export const getZonalUsers = createAsyncThunk("getZonalUsers", async () => {
  const idToken = sessionStorage.getItem("token"); // Retrieve the stored token

  if (!idToken) {
    throw new Error("No token found in sessionStorage");
  }

  const response = await GET({
    url: `${BASE_API_ENDPOINT}${API_END_POINT.getZonalUserList}`,
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${idToken}`,
    },
  });

  return response.data;
});
export const approveCreative = createAsyncThunk(
  "approveCreative",
  async ({ payload }) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await PUT({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.updateCreativeStatus(
        payload?.creativeId
      )}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
      body: payload,
    });

    return response.data;
  }
);

export const reAssignCreative = createAsyncThunk(
  "reAssignCreative",
  async (formData, { rejectWithValue }) => {
    try {
      const idToken = sessionStorage.getItem("token");

      if (!idToken) {
        throw new Error("No token found in sessionStorage");
      }
      const response = await POST({
        url: `${BASE_API_ENDPOINT}${API_END_POINT.reassignCreative}`,
        body: formData,
        headers: {
          accesstoken: sessionStorage.getItem("accessToken"),
          "Content-Type": "application/json",
          authorization: `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to upload file");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getImageTags = createAsyncThunk(
  "getImageTags",
  async (formData) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getImageTags}`,
      body: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const convertPSDImage = createAsyncThunk(
  "convertPSDImage",
  async (formData) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.convertPSDImage}`,
      body: formData,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const registerUser = createAsyncThunk(
  "registerUser",
  async ({ payload, idToken }) => {
    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.registerUser}`,
      body: payload,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const getCommanDealers = createAsyncThunk(
  "getCommanDealers",
  async ({ payload, headers }) => {
    const idToken = sessionStorage.getItem("token"); // Retrieve the stored token
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }
    const queryString = new URLSearchParams(payload).toString();
    const response = await GET({
      url: `${commonDealerEndPoint}/api/v1/common/dealers?${queryString}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${headers.accessToken}`,
        token_payload: `{"id_token":"${headers.idToken}"}`,
      },
    });

    return response.data;
  }
);

export const getNotificationList = createAsyncThunk(
  "getNotificationList",
  async (payload) => {
    const idToken = sessionStorage.getItem("token"); // Retrieve the stored token
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.getNotificationList}?page=${payload?.page}&limit=${payload?.limit}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });

    return response.data;
  }
);

export const makeNotificationCountReset = createAsyncThunk(
  "makeNotificationCountReset",
  async () => {
    const idToken = sessionStorage.getItem("token"); // Retrieve the stored token
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await GET({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.makeNotificationCountReset}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });

    return response.data;
  }
);



export const changeNotificationStatus = createAsyncThunk(
  "changeNotificationStatus",
  async (payload) => {
    const idToken = sessionStorage.getItem("token");

    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }

    const response = await POST({
      url: `${BASE_API_ENDPOINT}${API_END_POINT.changeNotificationStatus}`,
      body: payload,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

export const editPost = createAsyncThunk(
  "editPost",
  async ({ id, updateData }, { rejectWithValue }) => {
    try {
      const idToken = sessionStorage.getItem("token");

      if (!idToken) {
        throw new Error("No token found in sessionStorage");
      }

      const response = await PUT({
        url: `${BASE_API_ENDPOINT}${API_END_POINT.editPost}/${id}`,
        body: updateData,
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      });

      if (!response.data) {
        throw new Error("No data received from server");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to edit post");
    }
  }
);

export const glocalLogoutHandler = createAsyncThunk(
  "glocalLogoutHandler",
  async () => {
    const idToken = sessionStorage.getItem("token"); 
    if (!idToken) {
      throw new Error("No token found in sessionStorage");
    }
    const response = await GET({
      url: `${glocalLogoutUrl}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${idToken}`,
      },
    });
    return response.data;
  }
);

const apiSlice = createSlice({
  name: "api",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    formValidStatusData: {
      isFormOneValid: false,
      isFormTwoValid: false,
      isFormThreeValid: false,
      isFormFourValid: false,
      isFormFiveValid: false,
    }, // Updated field name
    campaignData: {},
    adsetData: {},
    adsData: {},
    recentPosts: [],
    upcomingPosts: [],
    getAllPost: [],
    recentActivity: [],
    editedPost: {},
    isSavePostLoading: false,
    isPostActivityLoading: false,
    platformList: [],
    repositoryList: [],
    repositoryIDsList: [],
    isRepositoryLoading: false,
    createRepoLoading: false,
    foldersList: [],
    isCreativeUploaded: false,
    creativeData: null,
    getCreative: false,
    getRejectedCreative: false,
    getRejectedCreativeData: null,
    getZonalUsers: false,
    zonalUsers: null,
    approvedData: null,
    getCreativeData: null,
    getCommanDealers: false,
    commanDealers: null,
    isEditPostLoading: false,
    editPostSuccess: false,
    editPostError: null,
  },
  reducers: {
    setFormValidStatusData: (state, action) => {
      state.formValidStatusData = action.payload; // Mutate state with new data
    },
    resetEditPostState: (state) => {
      state.isEditPostLoading = false;
      state.editPostSuccess = false;
      state.editPostError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveCampaignData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(saveCampaignData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.campaignData = action.payload;
      })
      .addCase(saveCampaignData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(saveAdsetData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.adsetData = action.payload;
      })
      .addCase(saveAdsetData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(saveAdsData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.adsData = action.payload;
      })
      .addCase(saveAdsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(postActivity.pending, (state) => {
        state.isPostActivityLoading = true;
        state.error = null;
      })
      .addCase(postActivity.fulfilled, (state) => {
        state.isPostActivityLoading = false;
        state.error = null;
      })
      .addCase(postActivity.rejected, (state, action) => {
        state.isPostActivityLoading = false;
        state.error = action.payload || "Failed to post activity";
      })
      .addCase(getRecentPosts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.recentPosts = action.payload?.data?.recentPosts?.length
          ? action.payload?.data?.recentPosts.map((obj) => ({
              ...obj,
              ...{ platform: "Facebook", file: img1 },
            }))
          : [];
        state.upcomingPosts = action.payload?.data?.upcomingPosts?.length
          ? action.payload?.data?.upcomingPosts.map((obj) => ({
              ...obj,
              ...{ platform: "Facebook", file: img1 },
            }))
          : [];

        state.getAllPost = action.payload?.data?.getAllPost?.length
          ? action.payload?.data?.getAllPost.map((obj) => ({
              ...obj,
              ...{ platform: "Facebook", file: img1 },
            }))
          : [];
      })
      .addCase(getActivityLog.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.recentActivity = action.payload?.data?.recentActivity?.length
          ? action.payload?.data?.recentActivity.map((obj) => ({
              ...obj,
              ...{ platform: "Facebook", file: img1 },
            }))
          : [];
      })
      .addCase(getActivityLog.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(getRecentPosts.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(savePostMedia.pending, (state, action) => {
        state.isSavePostLoading = true;
      })
      .addCase(savePostMedia.fulfilled, (state, action) => {
        state.isSavePostLoading = false;
        state.isSavePostSuccess = true;
        state.editedPost = action.payload?.data || {};
      })
      .addCase(savePostMedia.rejected, (state, action) => {
        state.isSavePostLoading = false;
        state.error = action.error.message;
      })
      .addCase(getPlatformList.fulfilled, (state, action) => {
        state.platformList = action.payload?.data || [];
      })
      .addCase(findPostById.fulfilled, (state, action) => {
        state.editedPost = action.payload?.data || [];
      })
      .addCase(getRepository.pending, (state, action) => {
        state.isRepositoryLoading = true;
      })
      .addCase(getRepository.fulfilled, (state, action) => {
        state.repositoryList = action.payload?.data || [];
        if(action.payload?.data?.result?.length) state.repositoryIDsList = (action.payload?.data?.result).map(item => item._id);
        state.isRepositoryLoading = false;
      })
      .addCase(getRepository.rejected, (state, action) => {
        state.isRepositoryLoading = false;
      })
      .addCase(getRecentRepositoryFiles.fulfilled, (state, action) => {
        if(action.payload?.data?.result?.length) state.repositoryIDsList = (action.payload?.data?.result).map(item => item._id);
      })
      .addCase(searchRepository.fulfilled, (state, action) => {
        state.repositoryList = action.payload?.data || [];
      })

      .addCase(createRepository.pending, (state) => {
        state.createRepoLoading = true;
      })
      .addCase(createRepository.fulfilled, (state, action) => {
        state.createRepoLoading = false;
      })
      .addCase(createRepository.rejected, (state, action) => {
        state.createRepoLoading = false;
      })
      .addCase(uploadMultipleFiles.pending, (state) => {
        state.uploadMultipleLoading = true;
      })
      .addCase(uploadMultipleFiles.fulfilled, (state, action) => {
        state.uploadMultipleLoading = false;
      })
      .addCase(uploadMultipleFiles.rejected, (state, action) => {
        state.uploadMultipleLoading = false;
      })
      .addCase(getFolders.pending, (state) => {
        state.isRepositoryLoading = true;
      })
      .addCase(getFolders.fulfilled, (state, action) => {
        state.foldersList = action.payload?.data || [];
        state.isRepositoryLoading = false;
      })
      .addCase(getFolders.rejected, (state, action) => {
        state.isRepositoryLoading = false;
      })
      .addCase(uploadCreative.pending, (state) => {
        state.isCreativeUploaded = true;
      })
      .addCase(uploadCreative.fulfilled, (state, action) => {
        state.isCreativeUploaded = false;
        state.creativeData = action.payload;
      })
      .addCase(uploadCreative.rejected, (state, action) => {
        state.isCreativeUploaded = false;
        state.error = action.payload?.message || "An error occurred";
      })
      .addCase(getPendingCreatives.pending, (state) => {
        state.getCreative = true;
      })
      .addCase(getPendingCreatives.fulfilled, (state, action) => {
        state.getCreative = false;
        state.pendingCreativeData = action.payload;
      })
      .addCase(getPendingCreatives.rejected, (state, action) => {
        state.getCreative = false;
        state.error = action.payload?.message || "An error occurred";
      })
      .addCase(getZonalUsers.pending, (state) => {
        state.getZonalUsers = true;
      })
      .addCase(getZonalUsers.fulfilled, (state, action) => {
        state.getZonalUsers = false;
        state.zonalUsers = action.payload;
      })
      .addCase(getZonalUsers.rejected, (state, action) => {
        state.getZonalUsers = false;
        state.error = action.error.message;
      })
      .addCase(getApprovedCreatives.pending, (state) => {
        state.getCreativeApprovedList = false;
      })
      .addCase(getApprovedCreatives.fulfilled, (state, action) => {
        state.getCreativeApprovedList = true;
        state.approvedCreativesData = action.payload;
      })
      .addCase(getApprovedCreatives.rejected, (state, action) => {
        state.getCreativeApprovedList = false;
        state.error = action.error.message;
      })
      .addCase(approveCreative.pending, (state) => {
        state.isApproved = false;
      })
      .addCase(approveCreative.fulfilled, (state, action) => {
        state.isApproved = true;
        state.approvedData = action.payload;
      })
      .addCase(approveCreative.rejected, (state, action) => {
        state.isApproved = false;
        state.error = action.error.message;
      })
      .addCase(getRejectedCreatives.pending, (state) => {
        state.getRejectedCreative = false;
      })
      .addCase(getRejectedCreatives.fulfilled, (state, action) => {
        state.getRejectedCreative = true;
        state.getRejectedCreativeData = action.payload;
      })
      .addCase(getRejectedCreatives.rejected, (state, action) => {
        state.getRejectedCreative = false;
        state.error = action.error.message;
      })
      .addCase(getCreatives.pending, (state) => {
        state.getCreative = false;
      })
      .addCase(getCreatives.fulfilled, (state, action) => {
        state.getCreative = true;
        state.getCreativeData = action.payload;
      })
      .addCase(getCreatives.rejected, (state, action) => {
        state.getCreative = false;
        state.error = action.error.message;
      })
      .addCase(getCommanDealers.pending, (state) => {
        state.getCommanDealers = true;
      })
      .addCase(getCommanDealers.fulfilled, (state, action) => {
        state.getCommanDealers = false;
        state.commanDealers = action.payload;
      })
      .addCase(getCommanDealers.rejected, (state, action) => {
        state.getCommanDealers = false;
        state.error = action.error.message;
      })
      .addCase(editPost.pending, (state) => {
        state.isEditPostLoading = true;
        state.editPostSuccess = false;
        state.editPostError = null;
      })
      .addCase(editPost.fulfilled, (state, action) => {
        state.isEditPostLoading = false;
        state.editPostSuccess = true;
        state.editedPost = action.payload?.data || {};

        // If we want to update the post in the existing lists
        if (state.getAllPost.length && action.payload?.data?._id) {
          const postIndex = state.getAllPost.findIndex(
            (post) => post._id === action.payload.data._id
          );
          if (postIndex !== -1) {
            state.getAllPost[postIndex] = {
              ...state.getAllPost[postIndex],
              ...action.payload.data,
            };
          }
        }

        // Same for recent and upcoming posts if needed
        if (state.recentPosts.length && action.payload?.data?._id) {
          const postIndex = state.recentPosts.findIndex(
            (post) => post._id === action.payload.data._id
          );
          if (postIndex !== -1) {
            state.recentPosts[postIndex] = {
              ...state.recentPosts[postIndex],
              ...action.payload.data,
            };
          }
        }

        if (state.upcomingPosts.length && action.payload?.data?._id) {
          const postIndex = state.upcomingPosts.findIndex(
            (post) => post._id === action.payload.data._id
          );
          if (postIndex !== -1) {
            state.upcomingPosts[postIndex] = {
              ...state.upcomingPosts[postIndex],
              ...action.payload.data,
            };
          }
        }
      })
      .addCase(editPost.rejected, (state, action) => {
        state.isEditPostLoading = false;
        state.editPostSuccess = false;
        state.editPostError = action.payload || action.error.message;
      });
  },
});

export const { setFormValidStatusData, resetEditPostState } = apiSlice.actions; // Updated action name
export default apiSlice.reducer;
